/**
 * Retorna o estilo CSS associado a um status, grupo ou subgrupo da fatura específico.
 *
 * @param {string} name - O código (ex: '[PG] Pago', '[A1] A pagar') que representa o status/grupo/subgrupo.
 * @returns {string} O estilo CSS associado.
 */
export function setPanoramaInvoiceStatusColor(name) {
  const panoramaInvoiceSummaryStatusColorMap = {
    '[TT] Total': ' color: #000000;',

    // STATUSES
    // PAID
    '[PG] Pago': ' color: #00B050;',
    '[P1] Em dia': ' color: #00B050;',
    '[P2] Em atraso': ' color: #00B050;',
    '[L1] Em atraso < 10 dias': ' color: #00B050;',
    '[L2] Em atraso < 30 dias': ' color: #00B050;',
    '[L3] Em atraso < 60 dias': ' color: #00B050;',
    '[L4] Em atraso < 90 dias': ' color: #00B050;',
    '[L5] Em atraso > 90 dias': ' color: #00B050;',

    // OPEN
    '[AB] Aberto': ' color: #177178;',
    '[A1] A pagar': ' color: #177178;',
    '[A2] Sem fatura': ' color: #d6a1a1;',
    '[F1] 365: Atualizar endereço': ' color: #d6a1a1;',
    '[F2] 365: Criar usuário': ' color: #d6a1a1;',
    '[F3] Gerando OV': ' color: #d6a1a1;',
    '[F4] Gerando boleto': ' color: #d6a1a1;',
    '[F5] Enviando boleto': ' color: #d6a1a1;',

    // AGREEMENT
    '[DE] Acordo': ' color: #00A8CC;',
    '[D1] Acordo informal': ' color: #00A8CC;',
    '[D2] Acordo assinado': ' color: #00A8CC;',
    '[D3] Acordo terceirizado': ' color: #00A8CC;',

    // OVERDUE
    '[NA] Inadimplente': ' color: #E84545;',
    '[NA] Inadim.': ' color: #E84545;',

    // OPERATIONAL_CHARGE
    '[CO] Cobrança operacional': ' color: #E84545;',
    '[O1] Não cobrar': ' color: #E84545;',
    '[O2] Cobrar por telefone': ' color: #E84545;',
    '[O3] Pagamento com data definida': ' color: #E84545;',
    '[O4] Normalmente paga em atraso': ' color: #E84545;',

    // CHARGE_NOTIFIED
    '[CS] Cobrança notificada': ' color: #FF47E9;',
    '[S1] Enviar para Serasa': ' color: #FF47E9;',
    '[S2] Registrado no Serasa': ' color: #FF47E9;',

    // CHARGE_ON_HOLD
    '[CE] Cobrança em espera': ' color: #FF9A00;',
    '[E1] Relatório de energia/duplicidade': ' color: #FF9A00;',
    '[E2] Consumindo saldo': ' color: #FF9A00;',

    // OUTSOURCED_CHARGE
    '[CT] Cobrança terceirizada': ' color: #892CDC;',
    '[T1] Enviar cobrança terceirizada': ' color: #892CDC;',
    '[T2] Cobrança terceirizada registrada': ' color: #892CDC;',

    // JUDICIAL_CHARGE
    '[CJ] Cobrança judicial': ' color: #8E3200;',
    '[J1] Juizado especial': ' color: #8E3200;',
    '[J2] Justiça comum': ' color: #8E3200;',

    // LOSS
    '[RD] Perda': ' color: #BFBFBF;',
    '[R1] Perda ou prejuízo': 'color: #BFBFBF;',
  };

  return panoramaInvoiceSummaryStatusColorMap[name] || ' color: #177178;';
}
